import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import ProductNote from '../ProductNote/ProductNote'

import messages from './messages'
import s from './ProductNotes.scss'


const ProductNotes = (props) => {
  const {
    className, notesClassName, noteClassName,
    items, defaultStyles, hasTitle, dataTestId, withLinks, isMale,
  } = props

  const areItemsExist = Boolean(items && items.length)

  if (!areItemsExist) {
    return null
  }

  const _notesClassName = cx(notesClassName, {
    [s.defaultNotesStyles]: defaultStyles,
  })

  return (
    <div className={className}>
      {
        hasTitle && (
          <Box mb={16}>
            <Text message={messages.title} uppercase />
          </Box>
        )
      }
      <div className={_notesClassName} data-testid={dataTestId}>
        {
          items.map(({ name, image, img, slug, tooltipPosition }) => (
            <ProductNote
              key={name}
              className={cx(s.note, noteClassName)}
              isLink={withLinks}
              isMale={isMale}
              name={name}
              slug={slug}
              image={image || img}
              tooltipPosition={tooltipPosition}
            />
          ))
        }
      </div>
    </div>
  )
}

ProductNotes.propTypes = {
  items: PropTypes.array,
  hasTitle: PropTypes.bool,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  defaultStyles: PropTypes.bool,
  noteClassName: PropTypes.string,
  notesClassName: PropTypes.string,
  withLinks: PropTypes.bool,
  isMale: PropTypes.bool,
}

ProductNotes.defaultProps = {
  items: [],
  defaultStyles: true,
  hasTitle: false,
  withLinks: false,
  isMale: false,
}


export default ProductNotes
